import elementBase from "./elementBase.js";
import creator from "./creator.js"
import containerItem from "../item/container.js"

export default class Diaporama extends elementBase {
    objectType = "DiaporamaElement";
    styleColor = "rgba(66, 0, 162, 0.49)"; // Vert foncé
    Repeat = true;
    Diaporama = [];//list class element
    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }

    objectToClassValue(args = {}) {
        let diaporama = [];
        args = this.constructor.fromObjectToObject(args);
        if (args.diaporama) {
            for (const media of args.diaporama) {
                diaporama.push(creator(media.objectType, media));
            }
        }
        args.diaporama = diaporama;
        super.objectToClassValue(args);
        this.Repeat = args.repeat !== null && args.repeat !== undefined ? args.repeat : true;
        this.Diaporama = args.diaporama ? args.diaporama : [];
        this.Diaporama.forEach((d) => {d.parent = this});
    }

    static get Name() {
        return "Diaporama";
    }
    static variableOfInstance() {
        return [
            ...super.variableOfInstance(),
            { property: "Repeat", construct: Boolean, jsType: "Boolean" },
            { property: "Diaporama", construct: containerItem, jsType: "Array" },
        ];
    }
    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            { name: "Repeat", type: "booleanInput", dataType: "boolean"},
            { name: "Diaporama", type: "arrayInput", dataType: "object", options: elementBase, elementOption: "pageElement", elements: { name: "Diaporama", type: "objectInput", dataType: "object", options: elementBase }},
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput")
        ];
    }
    getStyle(currentElementIndex = null) {
        return {
            ...super.getStyle(currentElementIndex),
            position: 'absolute',
            cursor: 'move'
        };
    }
    swapArrayElement(index, move) {
        if (index < 0 || index > this.Diaporama.length) return;
        this.Diaporama.splice(index + move, 0, this.Diaporama.splice(index, 1)[0]);
    }
    static fromObject(object = {}) {
        return new this.prototype.constructor(object);
    }
    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            repeat: this.Repeat,
            contents: this.Diaporama.length > 0 ? this.Diaporama.map(media => media.toExportObject(variableArray, ressourceArray)) : [],
        };
    }
    toObject(minify = false) {
        return {
            ...super.toObject(minify),
            repeat: this.Repeat,
            diaporama: this.Diaporama.length > 0 ? this.Diaporama.map(media => media.toObject(minify)) : [],
        }
    }
    getFromPreviewId(id) {
        if (super.hasPreviewId(id) == true)
            return this;
        for (const media of this.Diaporama) {
            let result = media.getFromPreviewId(id);
            if (result != null)
                return result;
        }
        return null;
    }
}
